import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function PublicLegalDocument({ docType, children, appendWhenSaved = null }) {
  const [savedContent, setSavedContent] = useState("");
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    let active = true;
    api.get(`/api/legal-docs/${docType}`)
      .then(({ data }) => {
        if (active) setSavedContent(typeof data?.content === "string" ? data.content : "");
      })
      .catch(() => {
        if (active) setSavedContent("");
      })
      .finally(() => {
        if (active) setHasLoaded(true);
      });
    return () => { active = false; };
  }, [docType]);

  if (!hasLoaded || !savedContent.trim()) return children;
  return (
    <>
      <div className="space-y-8 prose prose-invert max-w-none" data-testid={`saved-legal-${docType}`} dangerouslySetInnerHTML={{ __html: savedContent }} />
      {appendWhenSaved}
    </>
  );
}